import {routeTo} from '@/utils/router'

import {team, TeamCategory, TeamMemberSlug, TeamMemberType} from './team'

const highlightedTeam: TeamMemberSlug[] = [
  TeamMemberSlug.igorDemcak,
  TeamMemberSlug.humaLofca,
  TeamMemberSlug.marekKrizka,
  TeamMemberSlug.rohiniPandit,
  TeamMemberSlug.janDohnal,
  TeamMemberSlug.jurajCvik,
  TeamMemberSlug.andrejSkok,
  TeamMemberSlug.peterMarcely,
]

const legalTeam: TeamMemberSlug[] = [
  TeamMemberSlug.igorDemcak,
  TeamMemberSlug.martinaSallay,
  TeamMemberSlug.humaLofca,
  TeamMemberSlug.marekKrizka,
  TeamMemberSlug.tomasOrsula,
  TeamMemberSlug.rohiniPandit,
  TeamMemberSlug.janDohnal,
  TeamMemberSlug.liviaMoraes,
  TeamMemberSlug.martinaCsaszari,
  TeamMemberSlug.viktorStark,
  TeamMemberSlug.petraHobinkova,
  TeamMemberSlug.jakubSvatek,
  TeamMemberSlug.patrikPoprocky,
  TeamMemberSlug.katarinaJancovic,
  TeamMemberSlug.katarinaBalaskova,
  TeamMemberSlug.michaelaMihok,
  TeamMemberSlug.valeriaEstrada,
  TeamMemberSlug.martaSkupnik,
  TeamMemberSlug.leonardoPeres,
  TeamMemberSlug.luciaHavasova,
  TeamMemberSlug.radkaKulkova,
  TeamMemberSlug.claudiaFernandezAreste,
  TeamMemberSlug.eduardPetrov,
  TeamMemberSlug.luciaVyletelkova,
  TeamMemberSlug.katarinaKobliskova,
]

const customerSuccessTeam: TeamMemberSlug[] = [
  TeamMemberSlug.peterMarcely,
  TeamMemberSlug.patriciaBalcova,
  TeamMemberSlug.nicoleFenech,
  TeamMemberSlug.darioFernandez,
  TeamMemberSlug.evamariaKorbelova,
  TeamMemberSlug.anetaMarcely,
]

const productTeam: TeamMemberSlug[] = [
  TeamMemberSlug.andrejSkok,
  TeamMemberSlug.patrikZakutansky,
  TeamMemberSlug.tomasJanek,
  TeamMemberSlug.simonaGerbocova,
  TeamMemberSlug.peterZuffa,
  TeamMemberSlug.erikZurvalec,
  TeamMemberSlug.zuzanaHavasova,
]

const bizDevTeam: TeamMemberSlug[] = [TeamMemberSlug.janBuza, TeamMemberSlug.michalPavljuk]

const marketingTeam: TeamMemberSlug[] = [
  TeamMemberSlug.dariiaHorobchenko,
  TeamMemberSlug.peterDuris,
  TeamMemberSlug.milanTomic,
]

const operationsTeam: TeamMemberSlug[] = [
  TeamMemberSlug.mariaMiskovic,
  TeamMemberSlug.ninaRybarova,
  TeamMemberSlug.michaelaFurikova,
]

const licensedAttorneys: TeamMemberSlug[] = [
  TeamMemberSlug.leonardoPeres,
  TeamMemberSlug.tomasOrsula,
  TeamMemberSlug.rohiniPandit,
  TeamMemberSlug.martinaSallay,
  TeamMemberSlug.igorDemcak,
  TeamMemberSlug.marekKrizka,
  TeamMemberSlug.viktorStark,
]

type TeamCategoryContent = {
  title: string
  teamMembers: TeamMemberType[]
}

const teamByCategory: Record<TeamCategory, TeamCategoryContent> = {
  [TeamCategory.highlighted]: {
    title: 'team.leadership-title',
    teamMembers: highlightedTeam.map((member) => team[member]),
  },
  [TeamCategory.legal]: {
    title: 'team.legal-title',
    teamMembers: legalTeam.map((member) => team[member]),
  },
  [TeamCategory.customerSuccess]: {
    title: 'team.customer-success-title',
    teamMembers: customerSuccessTeam.map((member) => team[member]),
  },
  [TeamCategory.product]: {
    title: 'team.product-title',
    teamMembers: productTeam.map((member) => team[member]),
  },
  [TeamCategory.bizDev]: {
    title: 'team.business-development-title',
    teamMembers: bizDevTeam.map((member) => team[member]),
  },
  [TeamCategory.marketing]: {
    title: 'team.marketing-title',
    teamMembers: marketingTeam.map((member) => team[member]),
  },
  [TeamCategory.operations]: {
    title: 'team.operations-title',
    teamMembers: operationsTeam.map((member) => team[member]),
  },
}

export const getTeamContent = () => ({
  title: 'team.team-title',
  team: teamByCategory,
  licensedAttorneys: {
    title: 'team.our-team-title',
    description: 'team.our-team-desc',
    labels: [
      {
        imageSrc: '/images/icons/wtr.svg',
        imageAlt: 'WTR logo',
        title: 'team.our-team-label-0',
      },
      {
        imageSrc: '/images/icons/examiner.svg',
        imageAlt: 'Examiner',
        title: 'team.our-team-label-1',
      },
      {
        imageSrc: '/images/icons/stamp.svg',
        imageAlt: 'Stamp',
        title: 'team.our-team-label-2',
      },
      {
        imageSrc: '/images/icons/document-with-black-checkmark.svg',
        imageAlt: 'Document with a black checkmark',
        title: 'team.our-team-label-3',
      },
      {
        imageSrc: '/images/icons/heart.svg',
        imageAlt: 'Heart',
        title: 'team.our-team-label-4',
      },
      {
        imageSrc: '/images/icons/cursor.svg',
        imageAlt: 'Cursor',
        title: 'team.our-team-label-5',
      },
    ],
    button: {
      linkText: 'team.learn-more-about-us-title',
      linkHref: routeTo.aboutUs.home(),
      trackedEvent: 'Learn more about us is clicked',
    },
    teamMembers: licensedAttorneys.map((member) => team[member]),
  },
})
